<template>
  <div class="zi-piece flex-row" :key="piece.name">
    <div class="zi-bust">
      <img v-bind="props.piece.model" sizes="400px" />
    </div>
    <div class="description-container flex-column">
      <img
        v-if="props.piece.signature"
        v-bind="SignatureHeader[0]"
        sizes="112px"
        :style="{ 'min-width': '112px' }"
        alt="Signature Series"
        class="padded img-responsive"
      />
      <img
        v-else
        v-bind="ZiHeader[0]"
        sizes="120px"
        :style="{ 'min-width': '120px' }"
        alt="Zi Collection"
        class="padded img-responsive"
      />
      <h3 class="p-2xs-b">
        <template v-if="props.piece.signature">The </template>
        {{ props.piece.label || props.piece.name }}
      </h3>
      <p class="flex-static item-text">{{ props.piece.text }}</p>
      <div
        class="product-row flex-row flex-center flex-align-center"
        v-if="product"
      >
        <RouterLink
          :to="{ name: 'product-detail', params: { slug: product.slug } }"
        >
          <Button class="grey"> Shop Now </Button>
        </RouterLink>
        <WishlistAdd :product="product.id" />
      </div>
      <div v-if="product">
        <img
          v-if="props.piece.sig"
          v-bind="props.piece.sig"
          sizes="300px"
          :alt="props.piece.name"
          class="zi-signature-image"
        />
      </div>

      <div class="flex-center flex-align-center soldout" v-else>
        <div>
          <img
            v-if="props.piece.sig"
            v-bind="props.piece.sig"
            sizes="300px"
            :alt="props.piece.name"
            class="zi-signature-image"
          />
        </div>

        <h4>Sold Out</h4>

        <p>
          Click
          <RouterLink
            :to="{ name: 'shop', params: { path: 'zi-collection-2024' } }"
            >here</RouterLink
          >
          to shop more accessories from our 2024 Zi Collection.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import SignatureHeader from "@/assets/img/zi/SignatureSeries_Silver.png?preset=thumbnail";
import ZiHeader from "@/assets/img/zi/ZiCollectionLogo_Silver.png?preset=thumbnail";
import { useShopStore } from "@/stores/shop";
import type { ZiItem } from "@/stores/zi/zi_defs";
import Button from "primevue/button";
import { computed } from "vue";
import WishlistAdd from "../shop/WishlistAdd.vue";

const props = defineProps<{ piece: ZiItem }>();

const shop = useShopStore();

const product = computed(() =>
  shop.products.find((p) => p.remote_id === props.piece.sku),
);
</script>

<style scoped>
.zi-bust {
  flex: 1 1 auto;
  overflow: hidden;
  align-self: stretch;
  justify-self: stretch;
}

.zi-bust img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.zi-piece {
  padding: var(--XMd, 40px) var(--2XS, 8px);
  margin: 0 40px;
  width: calc(min(864px, 100%)) !important;
  /* width: 100%; */
  height: 100%;
  overflow-y: hidden;
  max-height: 85vh;
  background: white;
  gap: var(--md, 32px);
}
.zi-piece > * {
  flex: 1 1 1px;
}

.description-container {
  grid-area: meta;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 100%;
  gap: var(--md, 16px);
  padding-right: var(--2XS, 8px);
  justify-content: center;
}

h3 {
  color: var(--Black, #000);
  text-align: center;
  font-family: Indivisible;
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: uppercase;
  margin-top: -16px;
  margin-bottom: 0;
  border-bottom: 1px solid black;
}

p {
  margin: 0;
  font-size: 14px;
}

.description-container img {
  margin: 0 auto;
}
/* .description-container img:first-child {
  margin-top: 32px;
} */

.zi-signature-image {
  margin: 0 auto;
  max-height: 72px;
  display: block;
}

.product-row {
  gap: var(--2XS);
}

.soldout {
  margin: 0 auto;
  h4 {
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 300;
    margin: 0 0 var(--2XS, 8px) 0;
  }
  p {
    font-size: 14px;
    margin: 0;
    font-weight: 400;
    max-width: 300px;
    a {
      color: var(--Paparazzi-Pink, #ec008c);
      font-weight: 400;
    }
    a:hover {
      font-weight: 400;
    }
  }
  img.zi-signature-image {
    margin-bottom: 32px;
  }
}
</style>
